<template>
    <span class="fil">
        {{fil}}
    </span>
</template>
<style scoped>
    .fil {
        font-weight: bolder;
    }
    @media screen and (max-width: 420px) {  
        .fil {
            font-size: 11px;
        }
    }
</style>
<script >
export default {
    props: ['options'],
    computed: {
     fil() {
        var fil = "";
        if (typeof(this.options)!="undefined") {
        if (this.options.nbJoueursParEquipe != null) {
                switch (this.options.nbJoueursParEquipe) {
                    case -1:
                        fil += " Custom / "
                        break;
                    case 1:
                        fil += " Individuel / "
                        break;
                    case 2:
                        fil += " Doublette / "
                        break;
                    case 3: 
                        fil += " Triplette / ";
                        break;
                }
            }
       
        if (this.options.mode != null) {   
            
            switch (this.options.mode) {
                case "ALEA": 
                    fil += "Mélée / ";
                    break;
                case "FORME":
                    fil += "Formé / ";
                    break;
                }
        }
          if (this.options.competition != null) {
            switch (this.options.competition) {
                case 1: 
                    fil += "Tirage aléatoire";
                    break;
                case 2:
                    fil += "Gagnant Gagnant";
                    break;
                case 3:
                    fil += "Par poule";
                    break;
                }   
            
        }   
        return fil;
        }
         }
    }
 }   

</script>